module.exports = "<app-header></app-header>\r\n<div style=\"margin-top: 50px;\">\r\n    <router-outlet></router-outlet>\r\n</div>\r\n<app-loading><app-loading>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main